import { render } from "./ImagePolygonOutline.vue?vue&type=template&id=1faed6e8&scoped=true&ts=true"
import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=1faed6e8&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faed6e8"]])

export default __exports__